export default __webpack_public_path__ + "static/media/chevron-down-charcoal.1a0d27d4.svg";